export const INSURANCE_VALIDATION = {
  MIN_ADULT_AGE: 18,
};
